import axios from 'axios';
import store from '@/store';
import appConfig from '@/config/app';
import routeSetting from '@/config/router';
import { MessageBox, Message } from 'element-ui';
import auth from '@/core/auth'

// create an axios instance
const service = axios.create({
	baseURL: appConfig.api.host, // url = base url + request url
	withCredentials: appConfig.api.crossDomain, // send cookies when cross-domain requests
	timeout: appConfig.api.timeout // request timeout
});

// request interceptor
service.interceptors.request.use(
	config => {
		if (store.getters.token) {
			config.headers['Token'] = auth.getToken();
		}
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

// response interceptor
service.interceptors.response.use(
	response => {
		const res = response.data; 
		  
		if (res.status == undefined) {
			Message({
				message: '系统繁忙，请稍后再试',
				type: 'error',
				duration: 5000
			})
		} else if (res.status == 1004) {

			let hostname = window.location.hostname ? window.location.hostname : document.location.hostname;
			hostname = hostname.split('.');
			let host = hostname.length >= 3 ? host = hostname[0] : 'www'; 
			let config = routeSetting.config.hasOwnProperty(host) ? routeSetting.config[host] : {};
			
			if(config.checkToken) {
				MessageBox.confirm('您已退出登录，点击重新登录', '登录提示', {
					confirmButtonText: '重新登录',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => { 

					store.dispatch('user/resetToken').then(() => {
						location.reload()
					});
					
				});
			}

			return Promise.reject(new Error(res.msg || 'Error'));
		} else {
			return res;
		}


	},
	error => {
		Message({
			message: '网络连接错误',
			type: 'error',
			duration: 5 * 1000
		})
		return Promise.reject(error);
	}
);

export default service;



// WEBPACK FOOTER //
// ./src/core/request.js